import React, { useRef, useEffect, Ref } from 'react';

interface AutoResizingInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    onRender?: (textareaRef: Ref<HTMLTextAreaElement>) => void
}

const AutoResizingInput: React.FC<AutoResizingInputProps> = ({ value, onChange, onRender, ...rest }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height
      textarea.style.height = (textarea.scrollHeight-16) + 'px'; // Set to scroll height
    }
  }, [value]);


  useEffect(() =>  {
    onRender?.(textareaRef)
  }, [textareaRef])

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      rows={1}
      style={{
        width: '100%',
        resize: 'none',
        overflow: 'hidden',
        padding: '8px',
        fontSize: '16px',
        borderRadius: '4px',
      }}
      {...rest}
    />
  );
};

export default AutoResizingInput;